import { useState } from 'react';
import { TaskPage } from '../../../components/workbook/TaskPage';
import { RadioGroup, TextArea } from '../../../components/workbook/forms';
import { Callout } from '../../../components/workbook/Callout';

export default function ComparisonMethodPage() {
  const [method, setMethod] = useState('');
  const [pairwiseNotes, setPairwiseNotes] = useState('');
  const [weightedItems, setWeightedItems] = useState('');
  const [kanoItems, setKanoItems] = useState('');

  return (
    <TaskPage
      phase="arrange"
      title="Pick ONE Comparison Method"
      pageNumber={2}
      instruction="You only need one. Choose and commit. Timebox 10-15 minutes."
      whyItMatters="Keep the math simple and visible; transparency builds trust and reduces cognitive friction. One method per session avoids split attention."
      coachRail={{
        timing: "10-15 minutes",
        tips: "Pick one method and stick with it. Don't mix methods.",
        debrief: "Does the method feel right? Are the comparisons clear?"
      }}
    >
      <div className="space-y-6">
        <div className="bg-[var(--surface)] p-6">
          <h3 className="text-lg font-semibold text-[var(--text-pri)] mb-4">Choose Your Method</h3>
          <RadioGroup
            label="Which comparison method will you use?"
            options={[
              { value: 'pairwise', label: 'Option 1: Pairwise Ladder (fast tourney)' },
              { value: 'weighted', label: 'Option 2: Simple Weighted Score' },
              { value: 'kano', label: 'Option 3: Quick Kano-ish Sort' }
            ]}
            value={method}
            onChange={setMethod}
          />
        </div>

        {method === 'pairwise' && (
          <div className="bg-[var(--slate-dim)] border border-[var(--slate)] p-6">
            <h3 className="text-lg font-semibold text-[var(--text-sec)] mb-4">Pairwise Ladder</h3>
            <p className="text-sm text-[var(--text-sec)] mb-4">Pit A vs B, winner advances; repeat until one remains. Note why the winner beat the other (1 line each match).</p>
            <TextArea
              label="Pairwise comparisons"
              value={pairwiseNotes}
              onChange={(e) => setPairwiseNotes(e.target.value)}
              placeholder="A vs B: Winner is A because...&#10;B vs C: Winner is B because...&#10;(Continue until one remains)"
              rows={10}
            />
          </div>
        )}

        {method === 'weighted' && (
          <div className="bg-[var(--green-dim)] border border-[var(--green)] p-6">
            <h3 className="text-lg font-semibold text-[var(--green)] dark:text-[var(--text-ter)] mb-4">Simple Weighted Score</h3>
            <p className="text-sm text-[var(--green)] dark:text-[var(--text-ter)] mb-4">Formula: Impact (×2) + Confidence (×1) − Effort (×1) = score. Write the three ratings and the math next to each item.</p>
            <TextArea
              label="Weighted scores"
              value={weightedItems}
              onChange={(e) => setWeightedItems(e.target.value)}
              placeholder="Item 1: Impact(M×2) + Confidence(H×1) − Effort(S×1) = 2+1-1 = 2&#10;Item 2: ...&#10;(Keep weights visible)"
              rows={10}
            />
          </div>
        )}

        {method === 'kano' && (
          <div className="bg-[var(--slate-dim)] border border-[var(--slate)] p-6">
            <h3 className="text-lg font-semibold text-[var(--text-sec)] mb-4">Quick Kano-ish Sort</h3>
            <p className="text-sm text-[var(--text-sec)] mb-4">Must-have / Performance / Delight buckets; rank within each.</p>
            <TextArea
              label="Kano sort"
              value={kanoItems}
              onChange={(e) => setKanoItems(e.target.value)}
              placeholder="Must-have:&#10;1. Item A&#10;2. Item B&#10;&#10;Performance:&#10;1. Item C&#10;&#10;Delight:&#10;1. Item D"
              rows={10}
            />
          </div>
        )}

        <Callout type="tip" phase="arrange">
          <p className="text-sm">Keep the math simple and visible. Transparency builds trust and reduces cognitive friction.</p>
        </Callout>
      </div>
    </TaskPage>
  );
}






